import store from '@/store/index';
import { plansof } from '@/utils/chain';
import { ALLOW_MIXED_BUY_FREE_TRIAL_PLANS } from '../constants';
import BillingMessageBox from '@/components/common/message-box';

export const isSelectedPlanMixedFreeTrial = () => {
  const getSelectedPlans = store.getters.getSelectedPlans
  return plansof(getSelectedPlans).freeTrial().has() &&
    plansof(getSelectedPlans).not().freeTrial().has() &&
    plansof(getSelectedPlans) &&
    plansof(getSelectedPlans).type(...ALLOW_MIXED_BUY_FREE_TRIAL_PLANS).has()
}

export const filterOutFreeTrialPayloads = (payloads) => {
  if (payloads && payloads.length !== undefined) {
    return payloads?.filter(item => !item.trialCode)
  } else {
    return payloads
  }
}

export const showIneligibleDialogForFreeTrial = ({
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  customClass = 'partner-refer-message-popup',
} = {}) => {
  return BillingMessageBox.confirm(message, title, {
    confirmButtonText,
    cancelButtonText,
    closeOnClickModal: false,
    roundButton: true,
    customClass,
  }).catch(() => {
    return Promise.reject();
  }).then(() => {
    return Promise.resolve();
  });
}
